import React from "react";
import s from "./somePage.module.css";

/*

Νομίζω κάτι σαν "Ανάπτυξη Διαδικτυακής Γραφικής Διεπαφής για το Σύστημα Εξερευνητικής Αναζήτησης Ίππαλος"
"Development of a Web-based Graphical User Interface for the Hippalus Exploratory Search System

*/

export default () => (
  <div style={{ height: "100vh" }}>
    <div style={{ height: "100%", width: "100%" }}>
      <div style={{ height: "calc(100% - 40px)", overflow: "auto" }}>
        <div className="ml-3 mt-1" style={{ fontSize: 10 }}>
          *developed in 2019, this is a striped down modified version, detached
          from any backend integration.
        </div>
        <div className={s.cont}>
          <h3 className={s.author}>
            <a href="http://panoskouf.xyz" target="_blank" rel="noopener">
              Panagiotis Koufopoulos
            </a>
          </h3>
          <br />
          <div className={s.propWithText}>
            <span>Thesis</span>:&nbsp;&nbsp;&nbsp;
            <span style={{color: "#4928ff"}}>
              {" "}
              <b>Development of a Web-based Graphical User Interface for the
              Hippalus Exploratory Search System</b>
            </span>
          </div>
          <div className={s.propWithLink}>
            <span>Professor</span>:&nbsp;&nbsp;&nbsp;
            <a
              href="http://users.ics.forth.gr/~tzitzik/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Yiannis Tzitzikas
            </a>
          </div>
          <div className={s.propWithLink}>
            <span>Supervisor</span>:&nbsp;&nbsp;&nbsp;
            <a
              href="http://users.ics.forth.gr/~papadako/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Panagiotis Papadakos
            </a>
          </div>
          <div className={s.propWithText}>
            <span>Grade</span>:&nbsp;&nbsp;&nbsp;
            <span>10/10</span>
            </div>
          <br />
          
          <div className={s.infoCloud}><a
            href="http://users.ics.forth.gr/~tzitzik/publications/Tzitzikas_2014_ExploreDB.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Hippalus
          </a> is a publicly accessible web system demonstrating a preference-enriched FDT-based exploratory process. It
oers actions that allow the user to order facets, values, and objects using best, worst, prefer to actions (i.e. relative
preferences), around to actions (over a specic value), or actions that order them lexicographically, or according to
their values or count number.
</div>

<div>
          This UI implementation is written by me from scratch. The point of this thesis is to
          demonstrate the Single Page Application technology. This website is in
          fact just a static folder directory. Any server who can serve static
          files can serve this application which runs 100% in your browser.
          </div>
          <br />
          <br />
          <b>list of features</b>:
          <br />
          <br />
          <ul className="ml-3">
            <li>
              client side tabs implementation (top right), you can open/close
              tabs, you can open multiple tabs of the same dataset (open more
              tabs from the datasets route, explore column)
            </li>
            <li>
              resizable panels everywhere where items adjusting in realtime as
              you resize a panel{" "}
            </li>
            <li>
              implementation of a global application state, for this demo I've
              set the initial state to be equal with a snapshot of a state with
              two datasets open
            </li>
            <li><u>facets panel (left)</u></li>
            <ul>
              <li>supports images</li>
              <li>
                support nested items which can also nest other items
                indefinitely (until you run out of space)
              </li>
              <li>option to open images in modal</li>
              <li>
                option to select items (you can resize the panel to make
                selections more easily and then resize it back)
              </li>
              <li>
                right click for custom browser context menu, which also supports
                sub-menu items
              </li>
            </ul>
            <li><u>panel at the center</u></li>
            <ul>
              <li>option to close left or right panel</li>
              <li>compact settings in dropdown form</li>
              <li>
                supports map integration or full screen map, changes from the
                map icon next to settings
              </li>
              <li>hover in any item to see more information</li>
              <li>
                cloud of information opens regarding the position of item and
                the panel and user can interact with it
              </li>
              <li>items can be organized in buckets</li>
            </ul>
            <li><u>selections panel (right)</u></li>
            <ul>
              <li>Preference Priorities, to rate priority of items easily</li>
              <li>allows any number of dropdowns for tooling components</li>
            </ul>
          </ul>
        </div>
      </div>
    </div>
  </div>
);
